export default [
  {
    path: '/admin/visitation-route-plans',
    name: 'visitation-plan',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/visitation')
  },
  {
    path: '/admin/visitation-route-plans/create',
    name: 'visitation-plan-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/visitation/create.vue')
  },
  {
    path: '/admin/visitation-route-plans/:id/edit',
    name: 'visitation-plan-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/visitation/edit.vue')
  }
]